import axiosInstance from "../../api/axiosConfig";
import { superadminAuthHeaders } from "../superadmin/superadminSession";

const API_URL = "/analytics";

/**
 * Métricas de uso por cliente (colección `client_metrics` en el back). Solo superadmin:
 * todas las llamadas llevan el token. Las fechas son 'YYYY-MM-DD' inclusive.
 */
const AnalyticsService = {
  /** Totales de plataforma + fila por cliente en el rango (default: mes en curso). */
  getOverview: async (from, to) => {
    const { data } = await axiosInstance.get(`${API_URL}/overview`, {
      params: { from, to },
      headers: superadminAuthHeaders(),
    });
    return data;
  },

  /** Matriz cliente × mes de un año. */
  getMonthly: async (year) => {
    const { data } = await axiosInstance.get(`${API_URL}/monthly`, {
      params: { year },
      headers: superadminAuthHeaders(),
    });
    return data;
  },

  /** Serie diaria de un cliente. */
  getClientSeries: async (clientId, from, to) => {
    const { data } = await axiosInstance.get(`${API_URL}/clients/${clientId}/series`, {
      params: { from, to },
      headers: superadminAuthHeaders(),
    });
    return data;
  },

  /** Los 12 meses de un cliente. */
  getClientMonthly: async (clientId, year) => {
    const { data } = await axiosInstance.get(`${API_URL}/clients/${clientId}/monthly`, {
      params: { year },
      headers: superadminAuthHeaders(),
    });
    return data;
  },

  /** Estado EN VIVO de las sesiones de WhatsApp de todos los clientes. */
  getWhatsappLiveStatuses: async () => {
    const { data } = await axiosInstance.get(`/whatsapp/status/all`, { headers: superadminAuthHeaders() });
    return data || {};
  },

  /** Memoria del servidor, sockets abiertos e historial de 24 h (tarjeta "Servidor"). */
  getServerHealth: async () => {
    const { data } = await axiosInstance.get(`/whatsapp/server-health`, { headers: superadminAuthHeaders() });
    return data;
  },

  /** Registros a medias (pidieron OTP, no crearon cuenta) de los últimos N días. */
  getPendingLeads: async (days = 30) => {
    const { data } = await axiosInstance.get(`/registro/leads`, {
      params: { days },
      headers: superadminAuthHeaders(),
    });
    return Array.isArray(data) ? data : [];
  },
};

export default AnalyticsService;
